import { NavLink } from 'react-router-dom';
import styled from 'styled-components';
import SidebarData from './_sidebarData';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import { BsCalendar2Check } from 'react-icons/bs';
import { AiFillCaretRight } from 'react-icons/ai';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';

function Sidebar() {
  const permissions = useSelector((state) => state.user.permissions);
  const activeFiscalYear = useSelector((state) => state.fiscalyear.activeFiscalYear);
  const activeRole = useSelector((state) => state.user?.user?.active_role);
  return (
    <StyledSidebar className={`d-md-block sidebar-ani`}>
      <div className="d-flex sidebar-content flex-column justify-content-between align-items-center">
        <div className="mid-content">
          <OverlayTrigger
            placement="right"
            delay={{ show: 150, hide: 50 }}
            overlay={
              <Tooltip id="button-tooltip">
                Active <FormattedMessage id={'heading.fiscalYear'} />
              </Tooltip>
            }>
            <div className="fiscalYear holder position-relative">
              <div className="d-flex flex-column align-items-center">
                <BsCalendar2Check fontSize={26} />
                <span className="label mt-1">
                  <FormattedMessage id={'heading.fiscalYear'} />
                </span>
                <span
                  className="d-block"
                  title={activeFiscalYear?.title}
                  style={{ fontSize: '0.85rem', cursor: 'default' }}>
                  {activeFiscalYear?.title}
                </span>
              </div>
              <div className="activeMarker">
                <AiFillCaretRight fontSize={16} />
              </div>
            </div>
          </OverlayTrigger>
          <hr className="fiscalyear-divider m-auto" width="50%" />
          {SidebarData.filter((sidebarItem) => {
            if (sidebarItem.canViewRoles) {
              return sidebarItem.canViewRoles.includes(activeRole);
            }
            return (
              permissions[sidebarItem.view_permission] || sidebarItem.view_permission === 'true'
            );
          }).map((item) => {
            return (
              <NavLink
                key={item.id}
                to={item.url}
                className={({ isActive }) => (isActive ? 'navbar__link--active' : '')}
                end={item.exact}>
                <OverlayTrigger
                  placement="right"
                  delay={{ show: 150, hide: 50 }}
                  overlay={
                    <Tooltip id="button-tooltip">
                      <FormattedMessage id={item.name} />
                    </Tooltip>
                  }>
                  <div className="holder">
                    <div className="link d-flex flex-column align-items-center">
                      {item.icon}
                      <span className="label mt-1">
                        <FormattedMessage id={item.name} />
                      </span>
                    </div>
                  </div>
                </OverlayTrigger>
              </NavLink>
            );
          })}
        </div>
      </div>
    </StyledSidebar>
  );
}

export default Sidebar;

const StyledSidebar = styled.div`
  margin: 0px;
  padding: 0px;
  background: white;
  width: 5.4rem;
  .sidebar-content {
    background-color: white;
    list-style: none;
    height: 100%;
    padding: 0px;
  }

  .mid-content {
    width: 100%;
    .holder {
      margin-top: 0.5rem;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .fiscalYear {
      background: #d7ffd8;
      color: #444;
      padding: 0.5rem;
      margin-top: 0;
      margin-bottom: 0.5rem;
    }
    .activeMarker {
      border-radius: 1000px;
      width: 35px;
      height: 35px;
      display: flex;
      justify-content: center;
      align-items: center;
      background: #b3ffbc;
      position: absolute;
      top: 31%;
      right: -12%;
      box-shadow: -2px 0px 1px #d5d5d5cc;
    }
    .link {
      padding: 0.5rem 0;
      border-radius: 10px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      height: 75px;
      width: 75px;
      transition: background-color 200ms ease-in-out, transform 200ms ease-in-out;
      color: #757575;
      font-size: 0.9rem;
      svg {
        color: #757575;
      }
      &:hover {
        background-color: #e0f0ef;
      }
    }
  }
  .navbar__link--active {
    .holder {
      border-right: 3px solid #0d6efd;
    }
    .link {
      background-color: #e0f0ef !important;
      color: #0d6efd !important;
      svg {
        color: #0d6efd !important;
      }
    }
  }

  @media only screen and (max-width: 767px) {
    position: fixed;
    bottom: 0;
    width: 100vw;
    margin: 0;
    height: auto;
    z-index: 1;
    overflow-x: scroll;
    &::-webkit-scrollbar {
      display: none;
    }
    .fiscalyear-divider {
      display: none;
    }
    .sidebar-content {
      padding: 0;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      .mid-content {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        padding: 0 1rem;
      }

      .fiscalYear {
        margin-bottom: 0;
      }
      .navbar__link--active {
        .holder {
          border-right: none;
          border-top: 3px solid #0d6efd;
        }
      }
      .link {
        margin: 0.5rem 0;
        height: 60px;
        width: 60px;
        border: none !important;
        padding: 0.5rem;
        .label {
          display: none;
        }
      }
    }
  }
`;
